module.exports = __webpack_public_path__ + "img/20.4c98605c.jpeg";